import React, { Component, Fragment } from "react"
import { Button, Icon } from 'semantic-ui-react';
import { Link, NavLink }                                         from "react-router-dom"
import htmr                                                                           from "htmr";
import languageStore               from "stores/languageStore"
import Responsive from "react-responsive"


class Tooltips extends Component {

    state = {
        showToolTip: true,
    }

    render() {
    const { showToolTip } = this.state;
    const { toolTipToBeShown } = this.props;

    console.log("this.props", this.props)
    const { currentLanguage } = languageStore;
    return (
        <Fragment>
            {<Fragment>
            <div className="">
                <div className=" ">
            <Responsive minWidth={900}>
            {showToolTip && <div
            className="toolTipBanner">
              <div className="toolTipDemo"> 
                <div className="absolute top-1 right-1">
                    <button onClick={async () => { this.setState({ showToolTip: false }); }} style={{ height: "35px", width: "40px", border: "0px solid black", backgroundColor: "#a2cf66", borderRadius: "15px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                        <Icon className="pl1 white close"></Icon>
                        </button>
                </div>
                <div className="toolTipDemoDiv_header f3 fw7">
                    {toolTipToBeShown && htmr(translate(`${toolTipToBeShown}`))}
                </div>
                <div className="toolTipDemoDiv_desc f4 fw5">
                    {toolTipToBeShown && htmr(translate(`${toolTipToBeShown}_desc`))}
                </div>
                </div>  
            </div>}
            </Responsive>
            <Responsive maxWidth={899}>
            {showToolTip && <div
            className="toolTipBannerMobile">
              <div className="toolTipDemo"> 
                <div className="absolute top-1 right-1">
                    <button onClick={async () => { this.setState({ showToolTip: false }); }} style={{ height: "35px", width: "40px", border: "0px solid black", backgroundColor: "#a2cf66", borderRadius: "15px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                        <Icon className="pl1 white close"></Icon>
                        </button>
                </div>
                <div className="toolTipDemoDiv_header f3 fw7">
                    {toolTipToBeShown && htmr(translate(`${toolTipToBeShown}`))}
                </div>
                <div className="toolTipDemoDiv_desc f4 fw5">
                    {toolTipToBeShown && htmr(translate(`${toolTipToBeShown}_desc`))}
                </div>
                </div>  
            </div>}
                </Responsive>
                </div>
                </div>
                
                </Fragment>}
                
        </Fragment>
    );
    }
}

export default Tooltips;


// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Tooltips/Tooltips.js